import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import mixin from './common/mixin';
Vue.mixin(mixin);

import api from './common/api';
Vue.prototype.$_api = api;

import request from "@/common/request";
Vue.prototype.$_request = request;

import tools from "@/common/tools";
Vue.prototype.$tools = tools;
Vue.prototype.$_tools = tools;

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
